
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import ProfileIcon from '../profiles/ProfileIcon';
import { PlatformCardProps } from './types';

const PlatformCard = ({ platform, onSelect }: PlatformCardProps) => {
  return (
    <div 
      key={platform.id} 
      className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:shadow-card-hover hover:border-custom-primary dark:hover:border-custom-secondaryLight transition-all duration-300 cursor-pointer group bg-white dark:bg-gray-800/60"
      onClick={() => onSelect(platform)}
    >
      <div className="flex justify-between w-full items-start">
        <div className="h-10 w-10 rounded-full bg-custom-primaryLight dark:bg-custom-primary/20 flex items-center justify-center mb-2">
          <ProfileIcon platform={platform.platform} size="md" />
        </div>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-7 w-7 text-gray-400 hover:text-custom-primary dark:hover:text-custom-secondaryLight opacity-0 group-hover:opacity-100 transition-opacity" 
          onClick={e => {
            e.stopPropagation();
            onSelect(platform);
          }}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      <h4 className="font-medium text-custom-dark dark:text-gray-100 mt-2">{platform.name}</h4>
      <p className="text-sm text-gray-500 dark:text-gray-400">{platform.description}</p>
    </div>
  );
};

export default PlatformCard;
